import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import { toastr } from 'react-redux-toastr';
import styles from './FailImplantModal.module.scss';
import Modal from '../Shared/Modal/Modal';
import { Button } from '../Shared/Buttons';
import { AlertBox } from '../Shared/Alerts';
import * as patientActions from '../../redux/actions/patientActions';
import * as referenceDataActions from '../../redux/actions/referenceDataActions';
import { InputItem, InputRow } from '../Shared/Forms';
import { toastrOptions } from '../../constants/toastrOptions';

class FailImplantModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      failType: '',
      failDate: new Date(),
      failReason: '',
      failAction: '',
    };

    this.intl = props.intl;

    this.settingImplantFailed = false;

    this.hideFailImplantModal = this.hideFailImplantModal.bind(this);
    this.failImplant = this.failImplant.bind(this);

    this.failTypeChanged = this.failTypeChanged.bind(this);
    this.failDateChanged = this.failDateChanged.bind(this);
    this.failReasonChanged = this.failReasonChanged.bind(this);
    this.failActionChanged = this.failTypeChanged.bind(this);

    this.failTypes = props.failTypes.map((x) => ({
      key: x.key,
      value: this.intl.formatMessage({ ...x.label }),
    }));
    this.failReasons = props.failReasons.map((x) => ({
      key: x.key,
      value: this.intl.formatMessage({ ...x.label }),
    }));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.setImplantFailed.complete && this.settingImplantFailed) {
      this.setState({
        showSaveMenu: false,
      });
      this.settingImplantFailed = false;
      toastr.success(
        this.intl.formatMessage({ id: 'general.success', defaultMessage: 'Success' }),
        this.intl.formatMessage({
          id: 'failImplant.implantMovedToHistory',
          defaultMessage: 'Implant moved to history',
        }),
        toastrOptions
      );
      this.hideFailImplantModal();
    }
  }

  disableSave() {
    return !this.state.failType || !this.state.failDate || !this.state.failReason;
  }

  hideFailImplantModal() {
    this.setState(
      {
        failType: '',
        failDate: new Date(),
        failReason: '',
        failAction: '',
      },
      () => {
        if (this.props.hide) {
          this.props.hide();
        }
      }
    );
  }

  failImplant() {
    // if (this.props.selectedImplant <= 0) return;
    this.settingImplantFailed = true;
    this.props.actions.setImplantFailed(
      this.props.patient.sourceUserGroupId,
      this.props.patient.id,
      this.props.selectedImplant,
      this.state.failDate,
      this.state.failType,
      this.state.failReason
    );
  }

  failTypeChanged(event) {
    this.setState({
      failType: event.target.value,
    });
  }
  failDateChanged(date) {
    this.setState({
      failDate: date,
    });
  }
  failReasonChanged(event) {
    this.setState({
      failReason: event.target.value,
    });
  }
  failActionChanged(event) {
    this.setState({
      failAction: event.target.value,
    });
  }

  render() {
    const header = this.intl.formatMessage({
      id: 'failImplant.markImplantAsFailed',
      defaultMessage: 'Mark implant as failed',
    });

    const error = this.props.setImplantFailed.error;
    return (
      <Modal
        modalPanelClass={styles.modalPanel}
        header={header}
        onDismiss={this.hideFailImplantModal}
        show={this.props.show}
      >
        {error ? (
          <AlertBox
            color="black"
            headerText="Oops, there was an error"
            messages={error.messages.map((m) => m.text)}
          />
        ) : null}
        <div className={styles.content}>
          <div className={styles.column}>
            <div>
              <InputItem
                label={this.intl.formatMessage({
                  id: 'implant.typeOfFailure',
                  defaultMessage: 'Type of failure',
                })}
                type="selectbutton"
                options={this.failTypes}
                value={this.state.failType}
                onChange={this.failTypeChanged}
                centered
                onWhite
                span
              />
              {/* </InputRow>
            <InputRow> */}
              {/* <InputItem
                label={this.intl.formatMessage({
                  id: 'failImplant.failureDate',
                  defaultMessage: 'Failure date',
                })}
                type="text"
                value={this.state.failDate}
                onChange={this.failDateChanged}
                onWhite
              /> */}
              <InputItem
                // className={styles.date}
                label={this.intl.formatMessage({
                  id: 'implant.failureDate',
                  defaultMessage: 'Failure date',
                })}
                value={this.state.failDate}
                type="date"
                onChange={this.failDateChanged}
                onWhite
                timeVisible={false}
              />
            </div>
            <InputRow>
              <InputItem
                label={this.intl.formatMessage({
                  id: 'implant.reasonForFailure',
                  defaultMessage: 'Reason for failure',
                })}
                type="select"
                options={this.failReasons}
                defaultKey={'NoSelection'}
                defaultValue={''}
                value={this.state.failReason}
                onChange={this.failReasonChanged}
                onWhite
              />
            </InputRow>
            {/* <InputRow>
              <InputItem
                label={this.intl.formatMessage({
                  id: 'implant.additionalProcedures',
                  defaultMessage: 'Additional surgical procedures',
                })}
                type="select"
                options={this.failActions}
                noTranslate
                defaultKey={'NoSelection'}
                defaultValue={''}
                value={this.state.failAction}
                onChange={this.failActionChanged}
                onWhite
              />
            </InputRow> */}
          </div>
        </div>
        <div className={styles.buttons}>
          <Button
            value={this.intl.formatMessage({ id: 'general.cancel', defaultMessage: 'Cancel' })}
            onClick={this.hideFailImplantModal}
            diabled={this.settingImplantFailed}
          />
          <Button
            primary
            value={this.intl.formatMessage({
              id: 'failImplant.markAsFailed',
              defaultMessage: 'Mark as failed',
            })}
            onClick={this.failImplant}
            disabled={this.disableSave()}
            loading={this.settingImplantFailed}
          />
        </div>
      </Modal>
    );
  }
}

function mapState(state) {
  return {
    user: state.user.user,
    setImplantFailed: state.patient.setImplantFailed,
    patient: state.patient.currentPatient,
    failTypes: state.referenceData.implantFailureTypes,
    failReasons: state.referenceData.implantReasonForFailure,
    selectedImplant: state.patient.selectedPatientImplant,
    // implants: state.referenceData.implantData,
    // abutments: state.referenceData.abutmentData,
    // smartPegs: state.referenceData.smartPegData,
    // usedImplants: state.patient.usedImplants,
    // usedAbutments: state.patient.usedAbutments,
  };
}

function mapDispatch(dispatch) {
  return {
    actions: bindActionCreators({ ...patientActions, ...referenceDataActions }, dispatch),
  };
}

export default connect(mapState, mapDispatch)(injectIntl(FailImplantModal));
